var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PlaylistController = /** @class */ (function () {
    function PlaylistController() {
    }
    /*****************************************************************************************************
        * Is using route "api/playlist/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {PlaylistUploadDto} data
        * @param {File} media
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    PlaylistController.AddPlaylist = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    PlaylistController.DeletePlaylist = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistUploadDto} data
        * @param {File} media
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    PlaylistController.UpdatePlaylistCompletely = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.media)
            fd.append("media", data.media);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/addContent/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistContentUploadDto} data
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    PlaylistController.AddPlaylistContent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/addContent/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/removeContent/{id}/{contentId}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {string} contentId
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    PlaylistController.RemovePlaylistContent = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/removeContent/{id}/{contentId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/updateContents/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PlaylistContentUploadDto[]} contents
        * @returns {PlaylistDownloadDto}
    ******************************************************************************************************/
    PlaylistController.UpdatePlaylistContents = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/updateContents/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/assign/{userId}/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} userId
        * @param {string} playlistId
        * @returns {void}
    ******************************************************************************************************/
    PlaylistController.AssignPlaylistToUser = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assign/{userId}/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/use/{playlistId}" and http method "POST" to call the back-end.
    
        * @param {string} playlistId
        * @returns {void}
    ******************************************************************************************************/
    PlaylistController.UsePlaylist = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/use/{playlistId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/done/{itemId}/{finishedReferenceId?}" and http method "POST" to call the back-end.
    
        * @param {string} itemId
        * @param {string} finishedReferenceId
        * @returns {void}
    ******************************************************************************************************/
    PlaylistController.SetItemForPlaylists = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/done/{itemId}/{finishedReferenceId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/states" and http method "POST" to call the back-end.
    
        * @returns {ExtendedDataCollection<PlaylistStateDownloadDto, string>}
    ******************************************************************************************************/
    PlaylistController.GetPlaylistStates = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/states", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/item/state/{itemId}" and http method "GET" to call the back-end.
    
        * @param {string} itemId
        * @returns {ExtendedDataCollection<PlaylistStateDownloadDto, PlaylistItemStateEnum>}
    ******************************************************************************************************/
    PlaylistController.GetPlaylistItemState = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/item/state/{itemId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/isAssigned/{playlistId}" and http method "GET" to call the back-end.
    
        * @param {string} playlistId
        * @returns {boolean}
    ******************************************************************************************************/
    PlaylistController.IsPlaylistAssigned = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/isAssigned/{playlistId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/playlist/assignPerDefinitions" and http method "POST" to call the back-end.
    
        * @returns {boolean}
    ******************************************************************************************************/
    PlaylistController.AssignCurrentUserPerDefinitions = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/playlist/assignPerDefinitions", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return PlaylistController;
}());
export { PlaylistController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PlaylistController.js.map